const DATA_GROUP_NAME_ATTR = 'data-group-name';
const DATA_INSURANCE_TYPE_ATTR = 'data-insurance-type';
export const isAlwaysOpenInsurancePopup = (iataCode) => ['Y7'].includes(iataCode);
export function getInsuranceGroupNameAttr(groupName) {
    if (!groupName) {
        return {};
    }
    return { [DATA_GROUP_NAME_ATTR]: groupName };
}
export const getInsuranceTypeAttr = (insurancePrograms) => {
    if (!(insurancePrograms === null || insurancePrograms === void 0 ? void 0 : insurancePrograms.length)) {
        return {};
    }
    return { [DATA_INSURANCE_TYPE_ATTR]: insurancePrograms[0].type };
};
